/**
 * @param {object} univers
 * @returns 
 */
export default function Univers(obj = {}) {
  const {
    abonne = false,
    abonneCount = 0,
    consultationCount = 0,
    cote = null,
    dateConsultation = null,
    dateCreation = null,
    dateMaj = null,
    description = '',
    dosDtEntreeEnVigueur = null,
    favorite = false,
    gecDemandeQte = 1,
    gecDemandeType = "",
    hasThumbnail = false,
    id = 0,
    idEmploye = null,
    idPere = null,
    idPoste = null,
    localisation = null,
    qteDocument = 0,
    qteDocumentEndosse = 0,
    qteDocumentExpirer = 0,
    qteDocumentNonEndosse = 0,
    qteDossierAssocier = 0,
    qteDocumentsArchive = 0,
    secondaryCopyExist = false,
    shareCount = 0,
    site = '',
    title = '',
    typeDoc = null,
    evaluationPersonnel = null,
    evaluationMoyenne = null,
    dateEvenement = null,
  } = obj


  return {
    abonne,
    abonneCount,
    consultationCount,
    cote,
    dateConsultation,
    dateCreation,
    dateMaj,
    description,
    dosDtEntreeEnVigueur,
    favorite,
    gecDemandeQte,
    gecDemandeType,
    hasThumbnail,
    id,
    idEmploye,
    idPere,
    idPoste,
    localisation,
    qteDocument,
    qteDocumentEndosse,
    qteDocumentExpirer,
    qteDocumentNonEndosse,
    qteDossierAssocier,
    qteDocumentsArchive,
    secondaryCopyExist,
    shareCount,
    site,
    title,
    typeDoc,
    evaluationPersonnel,
    evaluationMoyenne,
    dateEvenement,
  }
}